import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'
import { injectIntl, FormattedMessage } from 'react-intl'
import sweetalert from 'sweetalert2'
import {
  CARD_ELEMENT_NAME_MAX_LENGTH
} from 'const/limits'
import {
  ContentHeader,
  ContentTitle,
  ContentIcon,
  ContentIconGroup
} from 'components/Content'
import {
  MenuItem
} from 'components/Menu'
import {
  ModalMenu
} from 'components/Modal'
import KanBoIcon from 'components/KanBoIcon'
import BusyOverlay from 'components/BusyOverlay'
import Editable from 'components/Editable'
import Content from '../Content'
import classes from './Element.module.scss'
import { withBoardPermission } from 'dataProviders/Board'
import styled from 'styled-components'

import Info from 'components/Info'

const StyledInfo = styled(Info)`
  margin-left: 0.5em;
`

const draggingStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: '#ccc',
  opacity: 0.8,
  zIndex: 2
}

export class Element extends React.Component {
  static propTypes = {
    cardContext: PropTypes.object.isRequired,

    intl: PropTypes.object.isRequired,

    permission: PropTypes.object.isRequired,

    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    isCardArchived: PropTypes.bool.isRequired,
    elementName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired,
    rightIcons: PropTypes.array.isRequired,
    isBusy: PropTypes.bool,
    isCollapsed: PropTypes.bool,
    menu: PropTypes.element,
    nameInfo: PropTypes.element,

    requestChangeElementName: PropTypes.func.isRequired,
    requestRemoveElement: PropTypes.func.isRequired,
    addLocalSetting: PropTypes.func.isRequired,
    removeLocalSetting: PropTypes.func.isRequired,

    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.func
    ]),

    sortable: PropTypes.object.isRequired,
    collapsible: PropTypes.bool
  }

  static defaultProps = {
    rightIcons: []
  }

  state = {
    isEditing: false
  }

  handleEditToggle = (isEditing) => {
    this.setState({
      isEditing
    })
  }

  handleNameValidate = ({ name }) => {
    const { intl } = this.props

    const errors = {}

    if (!name) {
      errors.name = intl.formatMessage({ id: 'CARD_ELEMENT_NAME_EMPTY' })
    } else if (name.length > CARD_ELEMENT_NAME_MAX_LENGTH) {
      errors.name = intl.formatMessage({ id: 'CARD_ELEMENT_NAME_TOO_LONG' })
    }

    return errors
  }

  handleNameSubmit = ({ name }) => {
    const {
      id,
      requestChangeElementName
    } = this.props

    if (name && name !== this.props.name) {
      requestChangeElementName({
        elementId: id,
        name
      })
    }
  }

  handleCollapseClick = () => {
    const { id, isCollapsed, addLocalSetting, removeLocalSetting } = this.props

    if (!isCollapsed) {
      addLocalSetting({
        id: 'collapseCardElement-' + id,
        value: true
      })
    } else {
      removeLocalSetting({
        id: 'collapseCardElement-' + id
      })
    }
  }

  handleRemoveClick = () => {
    const {
      cardContext,

      intl,

      id,
      name,

      requestRemoveElement,
    } = this.props

    sweetalert({
      text: intl.formatMessage({
        id: 'CARD_ELEMENT_REMOVE_QUESTION'
      }, {
        name
      }),
      confirmButtonText: intl.formatMessage({ id: 'REMOVE' }),
      cancelButtonText: intl.formatMessage({ id: 'CANCEL' }),
      showCancelButton: true,
      type: 'warning',
      confirmButtonClass: 'btn btn-warning'
    }).then(() => {
      requestRemoveElement({
        cardId: cardContext.id,
        elementId: id
      })
    }, () => {})
  }

  renderChildren = () => {
    const { isBusy, children, isCollapsed } = this.props

    if (isBusy) return null

    if (typeof children === 'function') {
      return children(isCollapsed)
    } else {
      return children
    }
  }

  render () {
    const {
      permission,
      isCardArchived,
      id,
      name,
      icon,
      rightIcons,
      isBusy,
      isCollapsed,
      menu,
      nameInfo,

      sortable,
      collapsible
    } = this.props
    const {
      isEditing
    } = this.state

    const isSortable = !sortable.disabled && !isEditing && !isBusy

    return (
      <Content
        className={classes.element}
      >
        {sortable.isDragging && <div style={draggingStyle} />}
        {isBusy && <BusyOverlay />}
        <ContentHeader
          key={isSortable} // TODO: fix this refresh sortable hack
          ref={ref => {
            const node = isSortable ? findDOMNode(ref) : null
            sortable.connectDragSource(node)
          }}
          className={isSortable ? classes.draggable : null}
        >
          <ContentIcon className={classes.icon}>
            {icon}
          </ContentIcon>
          <ContentTitle>
            {(!isCardArchived && permission.member) &&
              <Editable
                initialValues={{ name }}
                form={'cardElement-' + id}
                saveChanges
                editing={isEditing}
                validate={this.handleNameValidate}
                onSubmit={this.handleNameSubmit}
                onEditToggle={this.handleEditToggle}
              >
                {name}
                {nameInfo &&
                  <StyledInfo>
                    {nameInfo}
                  </StyledInfo>
                }
              </Editable>
            }
            {!(!isCardArchived && permission.member) &&
              <>
                {name}
                {nameInfo &&
                  <StyledInfo>
                    {nameInfo}
                  </StyledInfo>
                }
              </>
            }
          </ContentTitle>
          <ContentIconGroup>
            {collapsible &&
              <ContentIcon
                onClick={this.handleCollapseClick}
              >
                <KanBoIcon name={isCollapsed ? 'kanbo-16-chevron-left' : 'kanbo-16-chevron-down'} />
              </ContentIcon>
            }
            {rightIcons.map(rightIcon => rightIcon)}
            {(!isCardArchived && permission.member) &&
              <ModalMenu>
                <ContentIcon>
                  <KanBoIcon name='kanbo-16-options' />
                </ContentIcon>
                {Array.isArray(menu)
                  ? menu.map((menuItem, index) => {
                    if (React.isValidElement(menuItem)) {
                      return menuItem
                    }

                    const { title, ...menuItemProps } = menuItem

                    return (
                      <MenuItem
                        {...menuItemProps}
                        key={index}
                      >
                        {title}
                      </MenuItem>
                    )
                  })
                  : menu
                }
                <MenuItem
                  icon={<KanBoIcon name='kanbo-16-remove' />}
                  onClick={this.handleRemoveClick}
                >
                  <FormattedMessage id='REMOVE' />
                </MenuItem>
              </ModalMenu>
            }
          </ContentIconGroup>
        </ContentHeader>
        {this.renderChildren()}
      </Content>
    )
  }
}

export default injectIntl(withBoardPermission(Element), { forwardRef: true })
